// Keep the latest message in view through asynchronous image/font/layout changes,
// but stop following as soon as the reader scrolls back through the conversation.
export function createChatScroll(scroll:HTMLElement,content:HTMLElement,
  observe:(callback:()=>void)=>{observe(node:Element):void;disconnect():void}=callback=>new ResizeObserver(callback),
  schedule:(callback:()=>void)=>void=callback=>{requestAnimationFrame(callback);}){
 let following=true;let knownHeight=scroll.scrollHeight;let disposed=false;
 const atBottom=()=>scroll.scrollHeight-scroll.scrollTop-scroll.clientHeight<100;
 const settle=()=>{if(disposed)return;if(following)scroll.scrollTop=scroll.scrollHeight;knownHeight=scroll.scrollHeight;};
 const onScroll=()=>{
  // Growth can generate a browser scroll event before ResizeObserver runs.
  // It is not evidence that the reader chose to leave the latest messages.
  if(scroll.scrollHeight===knownHeight)following=atBottom();
 };
 const onWheel=(event:WheelEvent)=>{if(event.deltaY<0)following=false;};
 const stopFollowing=()=>{following=false;};
 const onKey=(event:KeyboardEvent)=>{if(['ArrowUp','PageUp','Home'].includes(event.key))following=false;};
 scroll.addEventListener('scroll',onScroll,{passive:true});scroll.addEventListener('wheel',onWheel,{passive:true});
 scroll.addEventListener('touchmove',stopFollowing,{passive:true});scroll.addEventListener('pointerdown',stopFollowing,{passive:true});scroll.addEventListener('keydown',onKey);
 const observer=observe(settle);observer.observe(content);observer.observe(scroll);
 return {
  element:scroll,
  render(follow:boolean){following=follow;settle();schedule(settle);},
  destroy(){disposed=true;observer.disconnect();scroll.removeEventListener('scroll',onScroll);scroll.removeEventListener('wheel',onWheel);scroll.removeEventListener('touchmove',stopFollowing);scroll.removeEventListener('pointerdown',stopFollowing);scroll.removeEventListener('keydown',onKey);}
 };
}
